import React, { useEffect, useState } from "react";
import styles from "./sendAddressModal.scss"
import { api } from "../../../../services";
import { constructAddress } from "./utils/constructAddress";
import ReactGA from "react-ga4";
import { Icon, Radio } from "antd";

interface AddressType {
  id: string | null; // null is for default address from profile
  countryId: string;
  countyId: string | null;
  cityId: string | null;
  settlementId: string | null;
  countryName?: string | null;
  countyName?: string | null;
  cityName?: string | null;
  settlementName?: string | null;
  fullName: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  phoneNumber: string;
  vatInvoiceLegalEntityName: string;
  isDefault: boolean;
}

interface Props {
  address: AddressType;
  setSelectedAddress: (address: AddressType) => void;
  isSelectedAddress: boolean;
  fetchAddresses: () => Promise<void> | void;
}



export const Address = ({ address, setSelectedAddress, isSelectedAddress, fetchAddresses }: Props) => {

  const handleClick = () => {
    ReactGA.event({
      category: "Inbox",
      action: "Click",
      label: "Odabrana postojeća adresa"
    });

    setSelectedAddress(address)
  }

  const handleDelete = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await api.UserAddress.delete(address.id);
      await fetchAddresses();
    } catch (error) {
    }
  }

  return (
    <div className={`${styles.address} ${isSelectedAddress ? styles.selectedAddress : ""}`} onClick={handleClick}>
        <Radio checked={isSelectedAddress} style={{ marginRight: 12}} />
      <div>
<p className={styles.addressTitle}>{address.street} {address.houseNumber ? address.houseNumber : ""}, {address.zipCode}
      </p>
      <p>
        {constructAddress(address)}
      </p>
      {address.vatInvoiceLegalEntityName && <p>{address.vatInvoiceLegalEntityName}</p>}
      
      <p>{address.fullName} · {address.phoneNumber}</p>

      {address.id && (
        <button
          type="button"
          className={styles.deleteIcon}
          aria-label="delete-address"
          onClick={handleDelete}
        >
          <Icon type="delete" />
        </button>
      )}

    </div>
      </div>
  )

}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/SendAddressModal/Address.tsx